export const AUTH_FORMS = { SIGN_IN: 'sign-in', JOIN: 'join' };
